import { render, staticRenderFns } from "./CacheManagement.vue?vue&type=template&id=74321ac6&"
import script from "./CacheManagement.vue?vue&type=script&lang=js&"
export * from "./CacheManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports